export default __webpack_public_path__ + "CV_Linkpick_pas_classique.6999b25.jpg";